module.exports = __webpack_public_path__ + "media/svg/logo-black-b615888c.svg";